import { render } from "./siderProfile.vue?vue&type=template&id=1498cd26"
import script from "./siderProfile.vue?vue&type=script&lang=js"
export * from "./siderProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__